import React from "react";
import { Qualifications, qualificationsNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";
import { isEmpty } from "../../common/StaticExports";

const QualificationsAutoComplete = (props:any) => {
    const { selectedValues, manageSelect, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
      {
        value: Qualifications.DC_Q_QUALIFICATION1,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION1]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION2,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION2]),
      },
      // {
      //   value: Qualifications.DC_Q_QUALIFICATION3,
      //   name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION3]),
      // },
      {
        value: Qualifications.DC_Q_QUALIFICATION4,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION4]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION5,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION5]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION6,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION6]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION7,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION7]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION8,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION8]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION9,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION9]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION10,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION10]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION11,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION11]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION12,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION12]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION13,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION13]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION14,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION14]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION15,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION15]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION16,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION16]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION17,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION17]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION18,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION18]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION19,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION19]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION20,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION20]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION21,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION21]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION22,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION22]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION23,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION23]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION24,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION24]),
      },
      {
        value: Qualifications.DC_Q_QUALIFICATION25,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION25]),
      },
      { value: Qualifications.DC_Q_QUALIFICATION26, 
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION26]) },
      {
        value: Qualifications.DC_Q_QUALIFICATION27,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION27]),
      },
      { value: Qualifications.DC_Q_QUALIFICATION28, 
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION28]) },
      {
        value: Qualifications.DC_Q_QUALIFICATION29,
        name: t(qualificationsNaming[Qualifications.DC_Q_QUALIFICATION29]),
      },
    ];

    const manageQualificationSelect = (d:any) => {
      let tempQuals = [];
      const index = selectedValues.findIndex((item:any) => item == d.value);
      if(index !== -1) {
        tempQuals = selectedValues.filter((item:any) => item != d.value);
      } else {
        tempQuals = [...selectedValues, d.value];
      }
      manageSelect(tempQuals);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageQualificationSelect} 
            label={t('DC_5_QUALIFICATIONS')}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            isError={isEmpty(selectedValues)}
            errorMessage={t('REQUIRED')}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default QualificationsAutoComplete;